import React from 'react';
import {  withRouter } from 'react-router-dom';

import {
    DownOutlined,
    LogoutOutlined,
    PicCenterOutlined,
    UserOutlined,
} from '@ant-design/icons';


//import { push } from 'connected-react-router';
import { Badge, Avatar, Menu, Dropdown, Input, Tag } from 'antd';
import { GlobalConfigContext } from '../../components/Config/GlobalConfigContext';
import { FormattedMessage } from 'react-intl';
//const { SubMenu } = Menu;
import { connect } from "react-redux";
import { bindActionCreators } from 'redux';
import * as authActions from '../../actions/auth'
import MessagesMenu from './MessagesMenu';
//import ActiveShiftsPopover from '../Cashiers/ActiveShiftsPopover';

class ProfileWidget extends React.PureComponent {
	static contextType = GlobalConfigContext;
	constructor(props, context) {
		super(props);
		this.state = {
            
            activeTempReservationsDrawer: false,
            visibleProperties: false,
            selectedProperty: context && context.activeProperty && context.activeProperty.id && context.activeProperty.id.toString(),
            query: null,
            activeProperties: context.properties || []
        }
        // console.log('this.state', this.state)
        //this.textInput = null;
        this.textInput = React.createRef();
        this.listRef = null;
        this.scrollIntoView = (index) => {
            //console.log(`this.listRef:`, this.listRef)
            // if (this.listRef.current) {
            //   this.listRef.current.scrollTo({ index });
            // }
          };
    }
    setTextInputRef = element => {
        this.textInput = element;
    }
    setListRef = element => {
        this.listRef = element;
    }
    focusTextInput = () => {
        //console.log(`focusTextInput:`, this.textInput, this.textInput.current)
        // Focus the text input using the raw DOM API
        //if (this.textInput) this.textInput.focus();
        if (this.textInput && this.textInput.current) {
            this.textInput.current.focus();
        }
    };
	componentDidMount() {
		//if(this.props.properties.length === 0){
	    	//this.props.propertiesActions.fetch('properties', {}); 
        //}
        //this.focusTextInput();
	}
	/*componentWillReceiveProps(nextProps) {
		console.log(`ProfileWidget componentWillReceiveProps:`, nextProps);
    }*/
    componentDidUpdate(prevProps, prevState){
        if(!prevState.visibleProperties && this.state.visibleProperties){
            //this.focusTextInput();
            setTimeout( () => this.focusTextInput(), 50);
            this.setState({ query: null });
        }else if(prevState.visibleProperties && !this.state.visibleProperties){
            this.setState({ query: null, selectedProperty: this.context.activeProperty && this.context.activeProperty.id.toString(), activeProperties: this.context.properties  });
        }else{
            setTimeout( () => this.focusTextInput(), 50);
        }

    }
	handlePropertyMenu = (menu) => {
		//console.log(`menu:`, menu)
		menu.domEvent.preventDefault();
		menu.domEvent.stopPropagation();
		//console.log('handlePropertyMenu', menu);
		//this.props.onLogout(value);
		if(menu.key === 'create-property'){
			this.props.onCreateProperty();
		}else if(menu.key === 'search-property'){
			//this.props.onCreateProperty();
		}else{
            this.setState({ selectedProperty: menu.key });
			const property = this.context.properties.find(property => property.id == menu.key);
            // dispatch clear store action
            this.props.authActions.activeProperty(property);
            this.context.setActiveProperty(property);
            //console.log(`this.props.location:`, this.props.location.pathname)
            if(this.props.location.pathname.includes('home')){
                this.props.history.push(this.props.location.pathname)
            }else{
                this.props.history.push('/')
            }
        }
        this.setState({ visibleProperties: false });
	}
	logout = (value) => {
		//this.props.onLogout(value);
		//this.context.handleLogout();
		this.props.dispatch(authActions.logout());
		const { history } = this.props;
		history.push('/');
	}
	handleQuickMenuClick = (item) => {
		if(item.key === 'temporary_reservations'){
			this.setState({ activeTempReservationsDrawer: true });
		}else if(item.key === 'checkout_reservations'){
			
		}
	}
	handleCloseTempReservationsDrawer = () => {
		this.setState({ activeTempReservationsDrawer: false });
	}
    stopEvent = (event) => {
        //console.log(`stopEvent:`, event)
        event.preventDefault();
		event.stopPropagation();
    }
    handleKeyDown = (e) => {
        //console.log(`e:`, e)
        //const { cursor, result } = this.state
        // arrow up/down button should select next/previous list element
        //console.log(`this.refs:`, this.refs)
        const currentIndex = this.state.activeProperties.findIndex(prope => prope.id.toString() === this.state.selectedProperty)
        //console.log(`currentIndex:`, currentIndex, this.state.activeProperties.length)
        if (e.keyCode === 38 && currentIndex > 0) {
            const curID = this.state.activeProperties[currentIndex - 1].id;
            //console.log(`curID:`, curID)
            //this.refs[curID].scrollIntoView({block: 'end', behavior: 'smooth'});
            this.setState({ selectedProperty: curID.toString() });
            this.scrollIntoView(curID);
        } else if (e.keyCode === 40 && currentIndex < this.state.activeProperties.length - 1) {
            const curID = this.state.activeProperties[currentIndex + 1].id;
            this.setState({ selectedProperty: curID.toString() });
            this.scrollIntoView(curID);
        }else if(e.keyCode === 13){
            e.preventDefault();
		    e.stopPropagation();
			const property = this.state.activeProperties.find(property => property.id == this.state.selectedProperty);
            //console.log(`property:`, property, this.state.selectedProperty)
            // dispatch clear store action
            if(property){
                this.setState({ visibleProperties: false });
                this.props.authActions.activeProperty(property);
			    this.context.setActiveProperty(property);
                //this.props.history.push('/');
                if(this.props.location.pathname.includes('home')){
                    this.props.history.push(this.props.location.pathname)
                }else{
                    this.props.history.push('/')
                }
            }
        }
    }
    handleVisibleChange = (visible) => {
        //console.log(`handleVisibleChange:`, visible)
        this.setState({ visibleProperties: visible });
        // if(visible){
        //     setTimeout( this.focusTextInput(), 5000);
        // }
    }
    handleSearchProperty = (e) => {
        //console.log(`handleSearchProperty:`, e.target.value)
        const query = e.target.value;
        const activeProperties = this.context.properties.filter(property => !query || (property.id == query || (property.name.toLowerCase() && property.name.toLowerCase().indexOf(query.toLowerCase()) >= 0)  ))
        this.setState({ query, activeProperties, ...(activeProperties && activeProperties.length) && { selectedProperty:activeProperties[0].id.toString() } });
    }
	render() {
		//console.log('ProfileWidget');
		//const { website, emailClient } = this.props;
        const { selectedProperty, activeProperties, query } = this.state;
		const { activeProperty, socketConnected, isMobile, ability } = this.context;
        
        //console.log(`resellerSupport:`, resellerSupport)
		//console.log(properties);
		// console.log('this.context', this.context)
        let roleName; 
        switch (this.context.user.role){
          
            case 'trainer':
                roleName=`${this.context.user.trainer_firstname} ${this.context.user.trainer_lastname}`
                break;
            case 'representative':
                roleName=`${this.context.user.representative_firstname} ${this.context.user.representative_lastname}`
                break;
            case 'beauty_advisor':
                roleName=`${this.context.user.beauty_advisor_firstname} ${this.context.user.beauty_advisor_lastname}`
                break;
            case 'admin':
                roleName=`Διαχειριστής`
                break;
            case 'manager':
                roleName=`Διαχειριστής Manager`
                break;
                // Add more cases as needed
            default:
                // Code to be executed if no case matches

        }
		const profileMenu = (
		  <Menu>
                {roleName && <Menu.Item key="1"  icon={<UserOutlined />}><span ><FormattedMessage id="layout.profile.test" defaultMessage={`${roleName}`} /></span></Menu.Item>}
                
				{/*<Menu.Item key="1"><Link to={"/profile"}><Icon type="home" /> <FormattedMessage id="layout.profile.profile" defaultMessage={`Profile`} /></Link></Menu.Item>*/}
				{/* ability.can('navigate', 'UserProfile') && <Menu.Item key="2" icon={<SettingOutlined />}><Link to={"/settings"}><FormattedMessage id="layout.profile.settings" defaultMessage={`My profile`} /></Link></Menu.Item> */}
                {/* <Menu.Item key="updates" icon={<RocketOutlined />}><Link to={"/updates/home"}><FormattedMessage id="layout.profile.updates" defaultMessage={`Updates`} /> {process.env.REACT_APP_VERSION}</Link></Menu.Item> */}
				{/* consider adding a simple setup form field so that the user can visit their email client from within our application */}
				{/*<Menu.Item key="4" disabled={true}><a target="_blank" href={emailClient}></a><Icon type="mail" /> <FormattedMessage id="layout.profile.mail" defaultMessage={`View Mail`} /></Menu.Item>*/}
				{/* <Menu.Item key="3" icon={<ReloadOutlined />}><span onClick={() => window.location.reload(true)}><FormattedMessage id="layout.profile.update" defaultMessage={`Update Hotelizer`} /></span></Menu.Item> */}
				<Menu.Item key="2" icon={<LogoutOutlined />}><span onClick={this.logout}><FormattedMessage id="layout.profile.sign-out" defaultMessage={`Αποσύνδεση`} /></span></Menu.Item>
		  </Menu>
		);
		
		const propertyOptions = [];
        activeProperties.map(d => propertyOptions.push(<Menu.Item key={d.id} ref={d.id}>{d.name}</Menu.Item>) );
        //console.log(`propertyOptions:`, propertyOptions);
        const defaultProperty = activeProperties && activeProperties.length ? activeProperties[0].id : null;
        //console.log(`defaultProperty:`, defaultProperty, selectedProperty)
        
		const propertyMenu = (
			<Menu onClick={this.handlePropertyMenu} selectedKeys={selectedProperty && activeProperties.find(property => property.id == selectedProperty) ? [selectedProperty] : [defaultProperty]} forceSubMenuRender={true} selectable={true} ref={this.setListRef}>
                <Menu.ItemGroup>
                    <Menu.Item key="search-property">
                        <Input.Search id="search-property" /*autoFocus={true}*/ ref={this.textInput} value={query} onKeyDown={ this.handleKeyDown } bordered={true} onClick={this.stopEvent} placeholder="Search for a property" onChange={this.handleSearchProperty} />
                    </Menu.Item>
                </Menu.ItemGroup>
                <Menu.ItemGroup title={false}>
				    {propertyOptions}
                </Menu.ItemGroup>
			</Menu>
		);
		
		// const quickMenu = (
		// 	<Menu onClick={this.handleQuickMenuClick}>
		// 		{ ability.can('record:create', 'Reservation') && <Menu.Item><Link to={"/reservations/new"}><PlusCircleOutlined /> <FormattedMessage id="layout.profile.add-reservation" defaultMessage={`Add Reservation`} /></Link></Menu.Item>}
		// 		{/*<Menu.Item key="checkout_reservations">
		// 			<ReservationStatus
		// 				//instanceKey={this.props.instanceKey}
		// 				defaultAction="action-2"
		// 			>
		// 				<Icon type="logout" /> <FormattedMessage id="layout.profile.checkout" defaultMessage={`Check out Reservations`} />
		// 			</ReservationStatus>
        //         </Menu.Item>*/}
		// 		{/*<Menu.Item key="temporary_reservations"><Icon type="book" /> <FormattedMessage id="layout.profile.temp-reservations" defaultMessage={`Temporary Reservations`} /></Menu.Item>*/}
		// 		{/* <Menu.Item><ActiveShiftsPopover /></Menu.Item> */}
		// 		{ ability.can('record:create', 'Contact') && <Menu.Item><Link to={"/contacts/new"}><PlusCircleOutlined /> <FormattedMessage id="layout.profile.add-contact" defaultMessage={`Add Contact`} /></Link></Menu.Item>}
		// 	</Menu>
		// );
		
		return !isMobile?(
			<span className="profile-widget">
				{/*!isSetup && <Dropdown overlay={quickMenu} trigger={['hover']} placement="bottomRight">
					<Link to={"/reservations/new"}><Icon type="plus-circle"  style={{ fontSize: 16 }} /></Link>
				</Dropdown>*/}
				
                { ability.can('navigate', 'Reservation') && activeProperty && <MessagesMenu property={activeProperty.id}/> }

				<Dropdown overlay={profileMenu} arrow={true} trigger={['click']} placement="bottomRight">
					<span className="profile-widget-item-last"><Badge dot style={{ backgroundColor: socketConnected ? '#52c41a' : '#f5222d' }}><Avatar size="default" icon={<UserOutlined />} className="profile-avatar" /></Badge> <DownOutlined /></span>
			    </Dropdown>
			    
			    {/* <span className="profile-search-">
				    <Dropdown overlay={quickMenu} arrow={true} trigger={['click']} placement="bottomRight">
						<Link to={"/reservations/new"}><PlusCircleOutlined style={{ fontSize: 16 }} /></Link>
					</Dropdown>
				</span> */}
		    </span>
		): (
				<span className="profile-widget">
                    {/* <Dropdown overlay={propertyMenu} trigger={['click']} placement="bottomRight" overlayClassName="profile-property-dropdown">
						<span className="profile-property" style={{ display: "inline-block" }}><PicCenterOutlined style={{ fontSize: 16 }} /></span>
					</Dropdown> */}
                    <Dropdown overlay={profileMenu} arrow={true} trigger={['click']} placement="bottomRight">
                        <span className="profile-widget-item-last"><Badge dot style={{ backgroundColor: socketConnected ? '#52c41a' : '#f5222d' }}><Avatar size="default" icon={<UserOutlined />} className="profile-avatar" /></Badge> <DownOutlined /></span>
                    </Dropdown>

				</span>
		);

	}
}

ProfileWidget.propTypes = {
	//onCreateProperty: PropTypes.func.isRequired,
}

const mapDispatchToProps = dispatch => ({
	authActions: bindActionCreators(authActions, dispatch),
	dispatch
})

export default withRouter(connect(null, mapDispatchToProps)(ProfileWidget));
//export default withRouter(ProfileWidget);

ProfileWidget.contextType = GlobalConfigContext;